import React from 'react';
import ListItemTextBase from '@material-ui/core/ListItemText';

const ListItemText = (props) => <ListItemTextBase {...props} />;

export default ListItemText;
